import { gql } from '../../api/graphql';

const ARCHIVED_TASKS_QUERY = `
  query GetArchivedUserTaskViews($days: Int!) {
    archived_user_task_views(days: $days) {
      tasks {
        uuid
        data
        due_at
        completed_at
        user_id
        facility_id
        facility { id name configuration }
        source_facility_id
        cross_facility
        driver_id
        completed_by_user_id
        completed_by_driver_id
        modified_by_user_id
        metadata
        is_paused
        created_at
        updated_at

        task_type { uuid type class }
        task_status { uuid status }

        from_location
        to_location
        from_object { type uuid name facility_zone_uuid facility_zone_name }
        to_object { type uuid name facility_zone_uuid facility_zone_name }

        trailer {
          trailer_number
          carrier_name
          lineage_uuid
          lineage_notes
        }

        related_movement_task {
          uuid
          from_location
          to_location
          from_object { type uuid name facility_zone_uuid facility_zone_name }
          to_object { type uuid name facility_zone_uuid facility_zone_name }
        }
      }
    }
  }
`;

export async function fetchArchivedUserTasks(days: number): Promise<any[]> {
  const data = await gql<{ archived_user_task_views: { tasks: any[] } }>(
    ARCHIVED_TASKS_QUERY,
    { days }
  );
  return data.archived_user_task_views.tasks || [];
}
